import { createSlice } from "@reduxjs/toolkit";

const collapseSlice = createSlice({
  name: "collapse",
  initialState: {
    workflowMetaData: [],
    workflowData: [],
    filteredWorkflowData: [],
    selectedRow: {},
  },
  reducers: {
    setWorkflowMetaData(state, action) {
      state.workflowMetaData = action.payload;
    },
    setWorkflowData(state, action) {
      state.workflowData = action.payload;
    },
    setFilteredWorkflowData(state, action) {
      state.filteredWorkflowData = action.payload;
    },
  },
});

export const { setWorkflowData, setWorkflowMetaData, setFilteredWorkflowData } =
  collapseSlice.actions;

export default collapseSlice.reducer;
